import { redirect, type LoaderFunctionArgs } from "react-router";
import { authedFetch } from "./api-client";
import type { ModuleSlug, ModuleStatus } from "@a2/core";

export async function requireSession({ request }: LoaderFunctionArgs) {
  const res = await authedFetch("/auth/me", { headers: { Accept: "application/json" } });

  if (res.status === 401) {
    const url = new URL(request.url);
    const next = url.pathname + url.search;
    return redirect(`/login?next=${encodeURIComponent(next)}`);
  }
  if (!res.ok) {
    throw new Response("Failed to verify session", { status: res.status });
  }
  const body = (await res.json()) as
    | { ok: true; data: SessionUser }
    | { ok: false; error: { code: string; message: string } };
  if (!body.ok) {
    return redirect("/login");
  }
  return body.data;
}

export type SessionUser = {
  firebaseUid: string;
  email: string;
  displayName: string;
  roles: ("student" | "admin")[];
  defaultModule: ModuleSlug | null;
  preferredLanguage: string | null;
  moduleStatusMap: Record<ModuleSlug, ModuleStatus>;
};
